var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../cn.js';
/** Wraps children in a `<label>` */
export const Label = forwardRef((_a, forwardedRef) => {
    var { children, label, optional, required, className } = _a, props = __rest(_a, ["children", "label", "optional", "required", "className"]);
    return (_jsxs("label", Object.assign({ "data-testid": "label", ref: forwardedRef, className: cn('body2 text-onSurface relative flex flex-col gap-100', className) }, props, { children: [label && (_jsxs("span", { children: [label, (optional || required) && (_jsxs("span", { className: "caption1 text-onSurfaceVariant", children: ['  ', required ? 'required' : 'optional'] }))] })), children] })));
});
//# sourceMappingURL=label.js.map